<template>
    <div>
      <!-- 头部开始 -->
      <!-- <siteNav></siteNav> -->
      <!-- 头部结束 -->
      <!-- 中间开始 -->
      <!-- <Header></Header> -->
        <!-- 中间结束 -->
      <shopHeader></shopHeader>
      <quanyi></quanyi>
      <tuijian></tuijian>
      <jifen></jifen>
      <xinpin></xinpin>
      <!-- 底部结束 -->
      <!-- <Footer></Footer> -->
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import Header from "@/components/canvasShow/cereshop/pc_b2c/header";
  import siteNav from "@/components/base_b2c/siteNav";
  import Footer from "@/components/base_b2c/footer";
  import shopHeader from "@/components/canvasShow/cereshop/pc_b2c/shopHeader";
  import tuijian from "./tuijian";
  import jifen from "./jifen";
  import xinpin from "./xinpin";
  import quanyi from "./quanyi";
  import api from "@/api";
  import { listSearchMixin } from "@/config/mixin";
  // 测试
  import imagesUrl from "@/assets/images/avatar.png";
  
  export default {
    mixins: [listSearchMixin],
    components: {
      Footer,
      siteNav,
      Header,
      shopHeader,
      tuijian,
      jifen,
      xinpin,
      quanyi
    },
    data() {
      return {
        // 测试
        imagesUrl,
        active: true,
        show: "",
        isShowImage: false,
      };
    },
    computed: {
      ...mapGetters(["userInfo"]),
    },
    mounted() {
      
    },
    methods: {
      
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  </style>


// WEBPACK FOOTER //
// src/views/b2c/index/index.vue